class VideoSectionFade {
  constructor() {
    this.videoSection = document.querySelector('.video-section');
    this.videoWrapper = document.querySelector('.video-banner__wrapper');
    
    if (this.videoSection && this.videoWrapper) {
      this.init();
    }
  }

  init() {
    this.updateFadePosition();
    
    // Update on window resize
    window.addEventListener('resize', this.debounce(() => {
      this.updateFadePosition();
    }, 100));
    
    // Update on orientation change (mobile)
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.updateFadePosition();
      }, 100);
    });
  }

  updateFadePosition() {
    const wrapperRect = this.videoWrapper.getBoundingClientRect();
    
    // Calculate position relative to document (not viewport) since we're using position: absolute
    // Add scroll position to convert from viewport coordinates to document coordinates
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Position the TOP of the gradient exactly at the bottom of the video wrapper
    const gradientStartTop = wrapperRect.bottom + scrollTop;
    
    // Set CSS custom property for the top position (absolute positioning relative to document)
    this.videoSection.style.setProperty(
      '--fade-top-position', 
      `${gradientStartTop}px`
    );
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new VideoSectionFade();
}); 